import(/* webpackMode: "eager" */ "/app/src/app/(beneficiary)/[userName]/page.tsx");
